type BarStylesProps = {
  isVertical: boolean;
  color: string;
  baseline: number;
  value: number;
  max: number;
  maxBarSize: number;
  showBarDiff?: boolean;
};

export const getBarStyles = ({
  max,
  value,
  color,
  baseline,
  maxBarSize,
  isVertical,
  showBarDiff = true,
}: BarStylesProps) => {
  const sizeCoef = maxBarSize / max;
  const valueAdjusted = value > baseline ? baseline : value;
  const showAdjustedValue = showBarDiff && baseline;
  const barValue = showAdjustedValue ? valueAdjusted : value;

  const borderClass = isVertical ? 'rounded-t' : 'rounded-e';
  const diffBarStyles = baseline < value ? color : 'bg-base-40';
  const baselineStyles = showAdjustedValue ? '' : borderClass;
  const barStyles = `${color} ${baselineStyles}`;
  const barSizeWithCoef = barValue * sizeCoef;

  return {
    diffBarStyles,
    barStyles,
    barSize: Number.isNaN(barSizeWithCoef) ? 1 : barSizeWithCoef,
    diffBarSize: showBarDiff ? Math.abs(baseline - value) * sizeCoef : 0,
  };
};
